import {DEVELOPER_MODE, routerOutlet} from '../../global';
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export interface IMenuItem {
    id?: string;
    type: string;       // Possible values: link/dropDown/extLink
    name?: string;      // Used as display text for item and title for separator type
    state?: string;     // Router state
    icon?: string;      // Material icon name
    tooltip?: string;   // Tooltip text
    disabled?: boolean; // If true, item will not be appeared in sidenav.
    sub?: IChildItem[]; // Dropdown items
    badges?: IBadge[];
    active?: boolean;
    outlets?: any;
    initialRoute?: string;
    is_hide: boolean;
    role?: number;
}

export interface IChildItem {
    id?: string;
    parentId?: string;
    type?: string;
    name: string;       // Display text
    state?: string;     // Router state
    icon?: string;
    sub?: IChildItem[];
    active?: boolean;
    outlets?: any;
    initialRoute?: string;
    is_hide: boolean;
    role?: number;
}

interface IBadge {
    color: string;      // primary/accent/warn/hex color codes(#fff000)
    value: string;      // Display text
}

interface ISidebarState {
    sidenavOpen?: boolean;
    childnavOpen?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    public sidebarState: ISidebarState = {
        sidenavOpen: true,
        childnavOpen: false
    };
    private activeTabIndex = 0;
    routerOutlet = routerOutlet;

    constructor() {
        if (DEVELOPER_MODE) {
            this.defaultMenu.push(
                {
                    name: 'Document',
                    type: 'dropDown',
                    tooltip: 'Document',
                    state: '/document',
                    icon: 'i-Bar-Chart',
                    initialRoute: '/document',
                    outlets: {outlets: {[this.routerOutlet['dashboard']]: 'dashboard'}},
                    is_hide: true,
                    sub: [
                        {
                            icon: 'i-Windows-2', name: 'Worksheet', initialRoute: '/document', state: '/document/worksheet', type: 'link', role: 0, is_hide: true,
                            outlets: {outlets: {[this.routerOutlet['dashboard']]: 'worksheet'}}
                        }
                    ]
                });
        }
    }

    defaultMenu: IMenuItem[] = [
        {
            name: 'DASHBOARD',
            type: 'link',
            tooltip: 'Dashboard',
            state: '/dashboard',
            icon: 'i-Bar-Chart',
            initialRoute: '/',
            outlets: {outlets: {[this.routerOutlet['dashboard']]: 'dashboard'}},
            is_hide: true,
            role: 3
        },
        {
            name: 'CLIENTS',
            type: 'dropDown',
            tooltip: 'Clients',
            icon: 'i-Administrator',
            is_hide: true,
            sub: [
                {
                    icon: 'i-Administrator', name: 'CUSTOMER', initialRoute: '/customer', state: '/customer/customer', type: 'link', is_hide: true, role: 4,
                    outlets: {outlets: {[this.routerOutlet['customer']]: 'customer'}}
                }
            ]
        },
        {
            name: 'FRANCHISE-MANAGEMENT',
            type: 'dropDown',
            tooltip: 'Franchise Management',
            icon: 'i-Building',
            is_hide: true,
            sub: [
                {
                    icon: 'i-Checked-User', name: 'AGENT', initialRoute: '/franchise-management', state: '/franchise-management/agent', type: 'link', is_hide: true, role: 5,
                    outlets: {outlets: {[this.routerOutlet['franchise-management']]: 'agent'}}
                },
                {
                    icon: 'i-Building', name: 'FRANCHISE', initialRoute: '/franchise-management', state: '/franchise-management/franchise', type: 'link', is_hide: true, role: 25,
                    outlets: {outlets: {[this.routerOutlet['franchise-management']]: 'franchise'}}
                },
                {
                    icon: 'i-Newsvine', name: 'BRANCH', initialRoute: '/franchise-management', state: '/franchise-management/branch', type: 'link', is_hide: true, role: 6,
                    outlets: {outlets: {[this.routerOutlet['franchise-management']]: 'branch'}}
                },
                {
                    icon: 'i-Clothing-Store', name: 'STORE', initialRoute: '/franchise-management', state: '/franchise-management/store', type: 'link', is_hide: true, role: 7,
                    outlets: {outlets: {[this.routerOutlet['franchise-management']]: 'store'}}
                },
            ]
        },
        {
            name: 'HRMS',
            type: 'dropDown',
            tooltip: 'HRMS',
            icon: 'i-Computer-Secure',
            is_hide: true,
            sub: [
                {
                    icon: 'i-Mens', name: 'TEAM-MANAGEMENT', state: '/hrms', type: 'dropDown', is_hide: true,
                    sub: [
                        {
                            icon: 'i-Administrator', name: 'EMPLOYEE', initialRoute: '/hrms', state: '/hrms/employee', type: 'link', is_hide: true, role: 8,
                            outlets: {outlets: {[this.routerOutlet['hrms']]: 'employee'}}
                        },
                        {
                            icon: 'i-Business-Man', name: 'DESIGNATION', initialRoute: '/hrms', state: '/hrms/designation', type: 'link', is_hide: true, role: 9,
                            outlets: {outlets: {[this.routerOutlet['hrms']]: 'designation'}}
                        },
                        {
                            icon: 'i-Building', name: 'DEPARTMENT', initialRoute: '/hrms', state: '/hrms/department', type: 'link', is_hide: true, role: 10,
                            outlets: {outlets: {[this.routerOutlet['hrms']]: 'department'}}
                        }
                    ]
                },
                {
                    icon: 'i-Mens', name: 'BACK-OFFICE', state: '/hrms', type: 'dropDown', is_hide: true,
                    sub: [
                        {
                            icon: 'i-Checked-User', name: 'BACK-OFFICE-USER', initialRoute: '/account-management', state: '/account-management/back-office-user', type: 'link', is_hide: true, role: 11,
                            outlets: {outlets: {[this.routerOutlet['account-management']]: 'back-office-user'}}
                        },
                        {
                            icon: 'i-Gear-2', name: 'USER-ROLE', initialRoute: '/authority-management', state: '/authority-management/user-role', type: 'link', is_hide: true, role: 12,
                            outlets: {outlets: {[this.routerOutlet['authority-management']]: 'user-role'}}
                        }
                    ]
                },
                {
                    icon: 'i-Business-Mens', name: 'VENDOR', initialRoute: '/hrms', state: '/hrms/vendor', type: 'link', is_hide: true, role: 13,
                    outlets: {outlets: {[this.routerOutlet['hrms']]: 'vendor'}}
                }
            ]
        },
        {
            name: 'APPLICATION-MANAGEMENT',
            type: 'dropDown',
            tooltip: 'HRMS',
            icon: 'i-Approved-Window',
            is_hide: true,
            sub: [
                {
                    icon: 'i-Newsvine', name: 'BRANCH', initialRoute: '/agency', state: '/agency/branch', type: 'link', is_hide: true, role: 14,
                    outlets: {outlets: {[this.routerOutlet['agency']]: 'branch'}}
                },
                {
                    icon: 'i-Checked-User', name: 'AGENT', initialRoute: '/agency', state: '/agency/agent', type: 'link', is_hide: true, role: 15,
                    outlets: {outlets: {[this.routerOutlet['agency']]: 'agent'}}
                }
            ]
        },
        {
            name: 'MARKETING',
            type: 'dropDown',
            tooltip: 'MARKETING',
            icon: 'i-Coins-2',
            is_hide: true,
            sub: [
                /*{
                    icon: 'i-Coins-3', name: 'DISCOUNT', initialRoute: '/hrms', state: '/hrms/discount', type: 'link', is_hide: true, role: 16,
                    outlets: {outlets: {[this.routerOutlet['hrms']]: 'discount'}}
                },*/
                {
                    icon: 'i-Tag-4', name: 'COUPON', initialRoute: '/hrms', state: '/hrms/coupon', type: 'link', is_hide: true, role: 17,
                    outlets: {outlets: {[this.routerOutlet['hrms']]: 'coupon'}}
                },
            ]
        },
        {
            name: 'PRODUCTS-SERVICES',
            type: 'dropDown',
            tooltip: 'Products & Services',
            icon: 'i-Windows-2',
            is_hide: true,
            sub: [
                {
                    icon: 'i-Windows-2', name: 'ATTRIBUTE', state: '/product-configuration/attribute', type: 'dropDown', is_hide: true,
                    sub: [
                        {
                            icon: 'i-Windows-2', name: 'LIST', initialRoute: '/product-configuration', state: '/product-configuration/attribute', type: 'link', is_hide: true, role: 18,
                            outlets: {outlets: {[this.routerOutlet['product-configuration']]: 'attribute'}}
                        },
                        {
                            icon: 'i-Windows-2',
                            name: 'VALUE',
                            initialRoute: '/product-configuration',
                            state: '/product-configuration/attribute-value',
                            type: 'link',
                            is_hide: true,
                            role: 18,
                            outlets: {outlets: {[this.routerOutlet['product-configuration']]: 'attribute-value'}}
                        },
                    ]
                },
                {
                    icon: 'i-Windows-2', name: 'PRODUCT', type: 'dropDown', is_hide: true,
                    sub: [
                        {
                            icon: 'i-Windows-2', name: 'PRODUCT', initialRoute: '/product-configuration', state: '/product-configuration/product', type: 'link', is_hide: true, role: 18,
                        },
                        {
                            icon: 'i-Windows-2', name: 'CATEGORY', initialRoute: '/product-configuration', state: '/product-configuration/category', type: 'link', is_hide: true, role: 18,
                            outlets: {outlets: {[this.routerOutlet['product-configuration']]: 'category'}}
                        },
                        {
                            icon: 'i-Windows-2', name: 'BRAND', initialRoute: '/product-configuration', state: '/product-configuration/brand', type: 'link', is_hide: true, role: 18,
                            outlets: {outlets: {[this.routerOutlet['product-configuration']]: 'brand'}}
                        },
                        {
                            icon: 'i-Windows-2', name: 'UNIT', initialRoute: '/product-configuration', state: '/product-configuration/unit', type: 'link', is_hide: true, role: 18,
                            outlets: {outlets: {[this.routerOutlet['product-configuration']]: 'unit'}}
                        }
                    ]
                },
                {
                    icon: 'i-Windows-2', name: 'SERVICE', type: 'dropDown', is_hide: true,
                    sub: [
                        {
                            icon: 'i-Gears-2', name: 'SERVICE', initialRoute: '/product-configuration', state: '/product-configuration/service', type: 'link', is_hide: true, role: 19,
                            outlets: {outlets: {[this.routerOutlet['product-configuration']]: 'service'}}
                        },
                        {
                            icon: 'i-Folder-Organizing', name: 'PACKAGE', initialRoute: '/product-configuration', state: '/product-configuration/package', type: 'link', is_hide: true, role: 20,
                            outlets: {outlets: {[this.routerOutlet['product-configuration']]: 'package'}}
                        },
                        {
                            icon: 'i-Money-2', name: 'EXTRA-CHARGE', initialRoute: '/hrms', state: '/hrms/extra-charge', type: 'link', is_hide: true, role: 21,
                            outlets: {outlets: {[this.routerOutlet['hrms']]: 'extra-charge'}}
                        }
                    ]
                }
            ]
        },
        {
            name: 'SUPPLIER-MANAGEMENT',
            type: 'dropDown',
            tooltip: 'HRMS',
            icon: 'i-Administrator',
            is_hide: true,
            sub: []
        },
        {
            name: 'FINANCIAL',
            type: 'dropDown',
            tooltip: 'HRMS',
            icon: 'i-Coins',
            is_hide: true,
            sub: [
                {
                    icon: 'i-Shopping-Cart', name: 'ORDER', initialRoute: '/sales', state: '/sales/order', type: 'link', role: 22, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['sales']]: 'order'}}
                },
                {
                    icon: 'i-Shopping-Cart', name: 'VOID-ORDER', initialRoute: '/sales', state: '/sales/void-order', type: 'link', role: 22, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['sales']]: 'void-order'}}
                },
                {
                    icon: 'i-Money-2', name: 'PAYMENT-LIST', initialRoute: '/sales', state: '/sales/payment', type: 'link', role: 22, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['sales']]: 'payment'}}
                },
                /*{
                    icon: 'i-Money-2', name: 'PAYMENT', type: 'dropDown', role: 0, is_hide: true,
                    sub: [
                        {
                            icon: 'i-Money-2', name: 'PAYMENT', initialRoute: '/sales', state: '/sales/payment', type: 'link', role: 22, is_hide: true,
                            outlets: {outlets: {[this.routerOutlet['sales']]: 'payment'}}
                        },
                        {
                            icon: 'i-Visa', name: 'PAYMENT-TYPE', initialRoute: '/hrms', state: '/hrms/payment-type', type: 'link', is_hide: true, role: 22,
                            outlets: {outlets: {[this.routerOutlet['hrms']]: 'payment-type'}}
                        },
                        {
                            icon: 'i-Visa', name: 'PAYMENT-CHARGE', initialRoute: '/sales', state: '/sales/payment-charge', type: 'link', is_hide: true, role: 22,
                            outlets: {outlets: {[this.routerOutlet['sales']]: 'payment-charge'}}
                        }
                        /!*{
                            icon: 'i-Money-2', name: 'PAYMENT-GATEWAY-LOGS', initialRoute: '/sales', state: '/sales/payment', type: 'link', role: 0, is_hide: true,
                            outlets: {outlets: {[this.routerOutlet['sales']]: 'payment'}}
                        }*!/
                    ]
                },*/
                {
                    icon: 'i-Shopping-Cart', name: 'COMMISSION-POST', initialRoute: '/sales', state: '/sales/commission-post', type: 'link', role: 26, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['sales']]: 'commission-post'}}
                }, {
                    icon: 'i-Shopping-Cart', name: 'SALE-COMMISSION', initialRoute: '/sales', state: '/sales/sale-commission', type: 'link', role: 26, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['sales']]: 'sale-commission'}}
                }, {
                    icon: 'i-Shopping-Cart', name: 'BALANCE-POOL', initialRoute: '/sales', state: '/sales/cust-balance-pool', type: 'link', role: 26, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['sales']]: 'cust-balance-pool-report'}}
                }]
        },
        {
            name: 'REPORT',
            type: 'dropDown',
            tooltip: 'Report',
            icon: 'i-Statistic',
            is_hide: true,
            sub: [
                {
                    icon: 'i-Statistic', name: 'SALES', state: '/report/sell', type: 'dropDown', is_hide: true,
                    sub: [
                        /*{
                            icon: 'i-Money-2', name: 'PRODUCT', initialRoute: '/report/sales', state: '/report/sales/product', type: 'link', role: 0, is_hide: true,
                            outlets: {outlets: {[this.routerOutlet['report']]: 'product'}}
                        },
                        {
                            icon: 'i-Money-2', name: 'PACKAGE', initialRoute: '/report/sales', state: '/report/sales/package', type: 'link', role: 0, is_hide: true,
                            outlets: {outlets: {[this.routerOutlet['report']]: 'package'}}
                        },
                        {
                            icon: 'i-Money-2', name: 'SERVICE', initialRoute: '/report/sales', state: '/report/sales/service', type: 'link', role: 0, is_hide: true,
                            outlets: {outlets: {[this.routerOutlet['report']]: 'service'}}
                        }*/
                    ]
                },
                {
                    icon: 'i-Money-2', name: 'YEAR', initialRoute: '/report/sales', state: '/report/sales/year', type: 'link', role: 78, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'year'}}
                },
                {
                    icon: 'i-Money-2', name: 'MONTHLY-SERVICE', initialRoute: '/report/sales', state: '/report/sales/monthly-service', type: 'link', role: 79, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'monthly-service'}}
                },
                {
                    icon: 'i-Money-2', name: 'DETAIL', initialRoute: '/report/sales', state: '/report/sales/sales-detail', type: 'link', role: 80, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'sales-detail'}}
                },
                {
                    icon: 'i-Money-2', name: 'BRANCH-WISE-SUMMARY', initialRoute: '/report/sales', state: '/report/sales/branch-wise-summary', type: 'link', role: 81, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'branch-wise-summary'}}
                },
                {
                    icon: 'i-Money-2', name: 'INCOME-SUMMARY-BRANCH-WISE', initialRoute: '/report/sales', state: '/report/sales/income-summary-branch-wise', type: 'link', role: 82, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'income-summary-branch-wise'}}
                },
                {
                    icon: 'i-Money-2', name: 'INTER-CROSS-REDEEM', initialRoute: '/report/sales', state: '/report/sales/intercreoss-redeem', type: 'link', role: 90, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'intercreoss-redeem'}}
                },
                {
                    icon: 'i-Money-2', name: 'BALANCE-POOL-REPORT', initialRoute: '/report/sales', state: '/report/sales/balance-pool-report', type: 'link', role: 91, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'balance-pool-report'}}
                },
                {
                    icon: 'i-Money-2', name: 'COMMISSION-REPORT', initialRoute: '/report/sales', state: '/report/sales/commission-report', type: 'link', role: 92, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'commission-report'}}
                },
                {
                    icon: 'i-Money-2', name: 'PAYMENT-REPORT', initialRoute: '/report/sales', state: '/report/sales/payment-report', type: 'link', role: 92, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'payment-report'}}
                },
                {
                    icon: 'i-Money-2', name: 'BRANCH-COMMISSION-REPORT', initialRoute: '/report/sales', state: '/report/sales/branch-commission-report', type: 'link', role: 92, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'branch-commission-report'}}
                },
                {
                    icon: 'i-Money-2', name: 'BRANCH-COMMISSION-PAYMENT-REPORT', initialRoute: '/report/sales', state: '/report/sales/branch-commission-payment-report', type: 'link', role: 92, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'branch-commission-payment-report'}}
                },
                {
                    icon: 'i-Money-2', name: 'AGENT-COMMISSION-REPORT', initialRoute: '/report/sales', state: '/report/sales/agent-commission-report', type: 'link', role: 92, is_hide: true,
                    outlets: {outlets: {[this.routerOutlet['report']]: 'branch-commission-report'}}
                }
            ]
        },
        {
            name: 'CMS',
            type: 'dropDown',
            tooltip: 'CMS',
            icon: 'i-Gears',
            is_hide: true,
            sub: [{
                icon: 'i-Flag-2', name: 'BANNER', initialRoute: '/cms', state: '/cms/banner', type: 'link', role: 24, is_hide: true,
                outlets: {outlets: {[this.routerOutlet['cms']]: 'banner'}}
            }]
        },
        {
            name: 'CONFIGURATION',
            type: 'dropDown',
            tooltip: 'CONFIGURATION',
            icon: 'i-Gear',
            is_hide: true,
            sub: [
                {
                    icon: 'i-Visa', name: 'PAYMENT-TYPE', initialRoute: '/hrms', state: '/hrms/payment-type', type: 'link', is_hide: true, role: 22,
                    outlets: {outlets: {[this.routerOutlet['hrms']]: 'payment-type'}}
                },
                {
                    icon: 'i-Coins-3', name: 'DISCOUNT', initialRoute: '/hrms', state: '/hrms/discount', type: 'link', is_hide: true, role: 16,
                    outlets: {outlets: {[this.routerOutlet['hrms']]: 'discount'}}
                },
            ]
        },
        {
            name: 'PLATFORM-SETTINGS',
            type: 'dropDown',
            tooltip: 'HRMS',
            icon: 'i-Administrator',
            is_hide: true,
            sub: []
        },
        {
            name: 'PERSONAL-PROFILE',
            type: 'link',
            tooltip: 'Personal Profile',
            state: '/personal-profile/profile',
            icon: 'i-Bar-Chart',
            initialRoute: '/personal-profile',
            outlets: {outlets: {[this.routerOutlet['personal-profile']]: 'profile'}},
            is_hide: true,
            role: 0
        }
    ];


    // sets iconMenu as default;
    menuItems = new BehaviorSubject<IMenuItem[]>(this.defaultMenu);
    // navigation component has subscribed to this Observable
    menuItems$ = this.menuItems.asObservable();

    // You can customize this method to supply different menu for
    // different user type.
    // publishNavigationChange(menuType: string) {
    //   switch (userType) {
    //     case 'admin':
    //       this.menuItems.next(this.adminMenu);
    //       break;
    //     case 'user':
    //       this.menuItems.next(this.userMenu);
    //       break;
    //     default:
    //       this.menuItems.next(this.defaultMenu);
    //   }
    // }

    setActiveTabIndex(index: number) {
        this.activeTabIndex = index;
    }

    getActiveTabIndex() {
        return this.activeTabIndex;
    }

    public getRouterOutlet(routeName: string) {
        return this.routerOutlet[routeName];
    }

}
